$(() => {
    if (document.getElementById('agent-client-contract-billing') !== null) {
        $('.js-contract-billing').on('click', () => {
            $('#agent-client-contract-billing-modal').modal('show');
        });
        $('.agent-client-contract-billing-exec').on('click', () => {
            $('#form').trigger('submit');
        });
    }
});